import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ComponentWithErrorModal } from '../../base/component-with-error-modal';
import { NotificationService, TpSafeService, SessionService } from '../../../services';
import { ModalService } from '../../../modules/modal';
import { FinalReport, Container } from '../../../models';

@Component({
  selector: 'final-report-repository',
  templateUrl: './final-report-repository.component.html',
})
export class FinalReportRepositoryComponent extends ComponentWithErrorModal implements OnInit {

  @Input() repositoryTranlsatedTitle: string;
  @Input() repositoryNonTranlsatedTitle: string;
  @Input() reports: FinalReport[];
  @Input() backToName: string;
  @Input() repositoryName: string;
  @Input() backToLink: string;

  @Output() refresh = new EventEmitter();

  workingContainer: Container;

  constructor(
    protected notificationsService: NotificationService,
    protected modalService: ModalService,
    private _tpSafeService: TpSafeService,
    private _sessionService: SessionService,
  ) {
    super(notificationsService, modalService);
  }

  ngOnInit(): void {
    this.workingContainer = this._sessionService.getWorkingContainer();
  }

  getSignedDownloadURL(filePath: string, fileName: string): void {
    this._tpSafeService.getSignedDownloadURL(filePath, fileName, this.workingContainer.containerId).subscribe((data) => {
      const signedUrl = data.data.url;
      this.downloadFile(signedUrl);
    });
  }

  deleteReport(/* reportId: number */): void {
    // this._tpSafeService.deleteLocalFileReport(localFileReportId).subscribe(() => {
    //   this.refresh.emit();
    // });
  }

  downloadFile(signedUrl: string): void {
    window.open(signedUrl, '_self');
  }

}
